/**
 * Sleep for a given amount of time - perfect for testing async code. Can be used inside then(), will pass the previous value through.
 * @param ms - The time to sleep in milliseconds.
 * @returns A function that returns a promise that resolves after the given time.
 * @example fetch("https://api.com").then(sleep(1000)).then((response) => console.log(response));
 */
export const sleep = function <T>(ms: number): (value: T) => Promise<T> {
    return (value: T) =>
        new Promise((resolve) => setTimeout(() => resolve(value), ms));
};
